import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import logo from '../lplogo_header.png';
import backgroundImg from '../leaseplan_login.jpg';
import LinearProgress from './Utils/LinearProgress';
import { connect } from 'react-redux';
import { logIn } from '../store/actions/login/loginActions';
import UserRoleAPI from '../API/UserRoleAPI';
import SnackbarAlert from './Utils/SnackbarAlert';
import { handleServerError } from '../Utils/Helper';
import { setLogoutTimeout, resetLogoutTimeout, onUnload } from '../Utils/Timer';
import Axios from 'axios';
import { logOut } from '../store/actions/login/loginActions';
import UserRoleApi from '../API/UserRoleAPI';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 264,
  },
  button: {
    margin: theme.spacing.unit,
    boxShadow: '0px 5px 7px 0px rgba(0, 0, 0, 0.30)',
    padding: '10px 26px',
  },
  menu: {
    width: 200,
  },
  loadingDiv: {
    height: '5px'
  },
  loginContent: {
    backgroundColor: '#FFFFFF',
    padding: '60px',
    position: 'absolute',
    transform: 'translate(-10%, -50%)',
    top: '50%',
    right: '10%',
    borderRadius: '26px',
  },
  loginMain: {
    background: '#fff url("' + backgroundImg + '") no-repeat',
    height: '100vh',
    width: '100%',
    backgroundSize: 'cover', 
  },
  title: {
    color: theme.palette.primary.main,
    fontSize: '24px',
  }
});

class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      loading: false,
      openError: false,
      openWarning: false,
      alertMessage: '',
    };
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleUsernameChange = this.handleUsernameChange.bind(this);
  }

  componentDidMount() {
    const userRoleApi = new UserRoleApi();
    
    userRoleApi.logout().then(ok => {
      this.props.logOut();
    }).catch(err => {
      console.log(err);
    })
  }

  handleUsernameChange(event) {
    this.setState({ username: event.target.value });
  }

  handlePasswordChange(event) {
    this.setState({ password: event.target.value });
  }

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      openWarning: false,
      alertMessage: ''
    });
  };


  handleSignIn(e) {
    e.preventDefault();

    let username = this.state.username;
    let password = this.state.password;

    this.loginPromise(username, password);
  }

  loginPromise = (username, password) => {

    this.setState({
      loading: true
    })

    const oUserRoleAPI = new UserRoleAPI();
    oUserRoleAPI.requestAuthorizationCookie(username, password).then(response => {
        var isAuthenticated = response.data.isAuthenticated;
        var timer = isAuthenticated ? 0 : 1000;

        if (!isAuthenticated) {
            this.setState({
                loading: false,
                openWarning: true,
                openError: false,
                alertMessage: 'Foi terminada uma sessão com este login noutro dispositivo!'
            })
        }

        setTimeout(() => {
            setLogoutTimeout(response.data.timeout, username);
            Axios.interceptors.response.use(response => {
                if (!response.config.url.includes("CheckUserLogin")) {
                    resetLogoutTimeout(username);
                }
                return response;
            }, error => {
                if (error.response.status === 401) {
                    window.removeEventListener("beforeunload", onUnload);
                    window.location.reload();
                }
                return Promise.reject(error);
            });
    
            oUserRoleAPI.requestUserRoles().then(response => {
                this.props.logIn(response);
            }).catch((error) => {
                this.setState({
                    loading: false,
                    openError: isAuthenticated ? true : false,
                    openWarning: false,
                    alertMessage: handleServerError(error)
                })
            });            
        }, timer)

    }).catch((error) => {
        if (error.response.status === 401) {
            error.response.data = 'Authorization has been denied for this request.';
        }
        this.setState({
            loading: false,
            openError: true,
            openWarning: false,
            alertMessage: handleServerError(error)
        })
        
    })

  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.loginMain}>
        <div className={classes.loginContent}>
          <img src={logo} alt='LeasePlan Logo' height='81' />
          <form onSubmit={this.handleSignIn.bind(this)}>
            <h3 className={classes.title}>Bulk Manager</h3>
            <TextField required
              label='Username'
              value={this.state.username}
              className={classes.textField}
              onChange={this.handleUsernameChange}
              type='text'
              autoComplete='current-user'
              margin='normal'
            />
            <br />
            <TextField required
              label='Password'
              value={this.state.password}
              className={classes.textField}
              onChange={this.handlePasswordChange}
              type='password'
              autoComplete='current-password'
              margin='normal'
            />
            <br />
            <br />
            <Button id='login' variant='contained' color='primary' type='submit' className={classes.button}>
              Login
          </Button>
          </form>
          {this.state.loading ?
            <LinearProgress color='primary' />
            : <div className={classes.loadingDiv}></div>
          }
          <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />
          <SnackbarAlert openWarning={this.state.openWarning} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />
        </div>
      </div>
    )
  }
}
LoginForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapstateToProps = state => {
  return {
    ...state
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logIn: (username, password) => dispatch(logIn(username, password)),
    logOut: () => dispatch(logOut())
  }
}

export default connect(mapstateToProps, mapDispatchToProps)(withStyles(styles)(LoginForm));


// WEBPACK FOOTER //
// ./src/components/LoginForm.js